/**
 * @file step
 * @author zhaomiaoyuan
 */
import React, {useCallback} from 'react';
import {withRouter} from 'react-router';
import PropTypes from 'prop-types';
import InputFormItem from '../../components/InputFormItem/index.tsx';

import {Button} from 'antd';
import {recordProxy, checkNumber} from '../../util';


const Step1 = (props) => {
    const {
        updateMark,
        markData,
        inputPlaceholder
    } = props;

    const nextClick = useCallback(() => {
        recordProxy('report_nextStep', 'click', markData.phone);
        updateMark({
            phoneErr: ''
        });
        if (!markData.phone) {
            updateMark({
                phoneErr: '不能为空'
            });
            return;
        }
        if (!checkNumber(markData.phone)) {
            updateMark({
                phoneErr: '号码格式不正确'
            });
            return;
        }
        updateMark({
            curStep: 2
        });
        window.scrollTo(0, 0);
    });
    /* eslint-enable */
    return (
        <div className="step-1">
            <InputFormItem
                placeholder={inputPlaceholder}
                type="phone"
                data={markData}
                updateData={updateMark}
                isMsgRequired
            />
            <Button
                type="primary"
                className="btn-step1"
                onClick={nextClick}
            >
                下一步
            </Button>
        </div>
    );
};

Step1.propTypes = {
    updateMark: PropTypes.func,
    markData: PropTypes.object,
    fetchAppealSearch: PropTypes.func,
    inputPlaceholder: PropTypes.string
};

export default withRouter(Step1);
